<template>
  <main class="flex justify-center font-zona">
    <div class="w-full min-[1200px]:w-4/5 max-[1200px]:mx-3 py-5 md:py-10">
      <img
        v-if="lang === 'mn'"
        src="../../../assets/images/miningMongolia/home-pages-cards/tsm.png"
        alt="responsible mining"
        class="w-60 h-20 object-contain"
      />
      <img
        v-else
        src="../../../assets/images/miningMongolia/home-pages-cards/tsm.png"
        alt="responsible mining"
        class="w-60 h-20 object-contain"
      />

      <section
        v-if="sustainableMining.length > 0 && !isLoading"
        class="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10"
      >
        <div
          v-for="(mining, index) in sustainableMining"
          :key="mining.id"
          class="space-y-3"
        >
          <h1 class="font-bold">
            {{ index + 1 }}. {{ lang === "mn" ? mining.title : mining.title }}
          </h1>
          <div class="flex items-start gap-3 w-full">
            <img
              v-for="(poster, mIndex) in mining.posters"
              :key="mIndex"
              :src="poster"
              :alt="mining.title"
              :style="{
                width: `${100 / mining.posters.length}%`,
              }"
              class="object-contain"
            />
          </div>

          <button
            @click="downloadFile(mining.pdf, mining.title)"
            class="flex items-center gap-2 border-b mt-3 text-sm text-gray-500 px-2.5 py-1 hover:text-green hover:border-green"
          >
            <font-awesome-icon icon="fa-solid fa-download" />
            <span class="text-start"> {{ mining.title }}.pdf </span>
          </button>
        </div>
      </section>

      <div
        v-else-if="sustainableMining.length === 0 && !isLoading"
        class="flex justify-center items-center w-full h-[10rem] mt-10 md:text-2xl bg-gray-100"
      >
        {{ lang === "mn" ? "Хуудас хоосон байна" : "No Data Found" }}
      </div>

      <div v-else class="flex justify-center items-center w-full h-[50vh]">
        <SpinLoading />
      </div>
    </div>
  </main>
</template>

<script>
import clientInstance from "@/lib/clientInstance";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import SpinLoading from "../../../components/ui/SpinLoading.vue";

export default {
  name: "SustainableMining",
  components: {
    SpinLoading,
  },
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const sustainableMining = ref([]);
    const isLoading = ref(null);

    const fetchSustainableMining = async () => {
      try {
        isLoading.value = true;
        const res = await clientInstance.get(
          `/get/sustainable-mining?lang=${lang.value}`
        );
        if (res.status === 200 && res.data.mining) {
          sustainableMining.value = res.data.mining;
        }
      } catch (err) {
        return err;
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchSustainableMining();
    });

    watch([() => lang.value], () => {
      fetchSustainableMining();
    });

    const downloadFile = (pdfUrl, title) => {
      fetch(pdfUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", title + ".pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error downloading file:", error));
    };

    return { lang, sustainableMining, isLoading, downloadFile };
  },
};
</script>
